<template>
  <img
    class="platform-avatar"
    :src="resolvedSrc"
    :alt="alt"
    decoding="async"
    @error="handleFailure"
  >
</template>

<script>
import { avatarUrl, handleAvatarError } from "../utils/media"

export default {
  name: "PlatformAvatar",
  props: {
    src: { type: String, default: "" },
    alt: { type: String, default: "" }
  },
  computed: {
    resolvedSrc() {
      return avatarUrl(this.src)
    }
  },
  methods: {
    handleFailure(event) {
      handleAvatarError(event)
      this.$emit("error", event)
    }
  }
}
</script>

<style scoped>
.platform-avatar{display:block;min-width:0;min-height:0;aspect-ratio:1;flex:none;border-radius:50%;background:var(--avatar-background,#25262d);object-fit:cover;object-position:center;overflow:hidden}
</style>
